import type { YardGateEntry } from './adapter';

export type DockAttentionState = Map<string, number>;

export const dockAttentionKey = (entry: YardGateEntry): string =>
  `${entry.type}-${entry.sourceId}`;

const dockAttentionSignal = (entry: YardGateEntry): number =>
  entry.dockAttentionRequired ? entry.dockAttentionCount : 0;

export const buildDockAttentionState = (
  entries: YardGateEntry[]
): DockAttentionState => {
  const state: DockAttentionState = new Map();
  entries.forEach((entry) => {
    state.set(dockAttentionKey(entry), dockAttentionSignal(entry));
  });
  return state;
};

export const hasNewRemoteDockChange = (
  previous: DockAttentionState | null,
  next: DockAttentionState
): boolean => {
  if (!previous) return false;

  let hasChange = false;
  next.forEach((signal, key) => {
    const previousSignal = previous.get(key);
    if (previousSignal === undefined) return;
    if (signal > previousSignal) hasChange = true;
  });
  return hasChange;
};
